<template>
  <div class="slide-out__outer">
    <transition name="fade">
      <div v-if="slideOut" class="slide-out__background" v-on:click="closeSlideOut()"></div>
    </transition>
    <div :class="['slide-out', slideOut ? 'open' : '']">

      <button type="button" class="slide-out__close" v-on:click="closeSlideOut()">
        <i class="far fa-times"></i>
      </button>

      <!-- This should be rendered using named views -->
      <template v-if="component">
        <component :is="component" v-bind="componentProperties"></component>
      </template>
      <!-- End of named view... -->

    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: {
    slideOut: {
      type: Boolean,
      required: false,
      default: false
    },
    component: {
      required: true
    },
    componentProperties: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      active: true
    }
  },
  methods: {
    ...mapMutations('global', {
      closeSlideOut: 'closeSlideOut'
    })
  }
}
</script>

